import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class BackgroundAttachment extends BaseOption {
  static userInterfaceComponent = {
    label: "Background Attachment",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          label: "Fixed",
          value: "fixed",
        },
        {
          label: "Scroll",
          value: "scroll",
        },
      ],
    },
  };

  static defaultValue = "scroll";
}
